import { isNil } from 'lodash-es';
import { FIELDS } from 'components/forms';

/**
 * @param {*} raw
 * @return {playerConfigurationModel.type}
 */
export const playerConfigurationModel = (raw) => ({
  playerDefinitionId: raw.playerDefinitionId,
  playerDomain: raw.playerDomain,
  playerApiDomain: raw.playerApiDomain,
});

/**
 * @typedef {{
 *  playerDefinitionId: string,
 *  playerDomain: string,
 *  playerApiDomain: string
 * }}
 */
playerConfigurationModel.type = null;

/**
 * @param {*} raw
 * @return {websiteModel.type}
 */
export const websiteModel = (raw) => ({
  id: +raw.id,
  name: raw.name || 'WebSiteName',
  videoManagerId: raw.videoManagerId,
  playerConfiguration: playerConfigurationModel(raw.playerConfiguration),
});

/**
 * @typedef {{
 *    id: number,
 *    name: string,
 *    playerConfiguration: playerConfigurationModel.type
 * }}
 */
websiteModel.type = null;

/**
 * @param {*} raw
 * @return {{name: (string), data: (*|{})}}
 */
export const permissionModel = (raw) => {
  const defaultModel = {
    name: 'permission',
    data: {},
  };

  if (isNil(raw)) return defaultModel;

  return {
    name: raw.name || defaultModel.name,
    data: isNil(raw.data) ? defaultModel.data : raw.data,
  };
};

/**
 * @param {*} raw
 * @return {{organizationGroup: string, permissions: permissionModel[]}}
 */
export const policyModelRaw = (raw) => {
  const defaultModel = { organizationGroup: 'group name', permissions: [] };

  if (isNil(raw)) return defaultModel;

  return {
    organizationGroup: raw.organizationGroup || defaultModel.organizationGroup,
    permissions: !isNil(raw.permissions) ? raw.permissions.map(permissionModel) : defaultModel.permissions,
  };
};

/**
 * @param {*} raw
 * @return {{id: number, organizationGroup: string, permissions: permissionModel[]}}
 */
export const policyModel = (raw) => {
  const defaultModel = { id: -1, organizationGroup: 'group name', permissions: [] };

  if (isNil(raw)) return defaultModel;

  function getPermissions() {
    if (raw.permissions === undefined) {
      return defaultModel.permissions;
    }

    if (raw.permissions === null) return raw.permissions;

    return raw.permissions;
  }

  return {
    id: +raw.id || defaultModel.id,
    organizationGroup: raw.organizationGroup !== undefined ? raw.organizationGroup : defaultModel.organizationGroup,
    permissions: getPermissions(),
  };
};

/**
 * Maps inconsistency between fields type and what is expected to be send as name key in request.
 */
const TYPE_NAME_MAP = {
  video_title: FIELDS.VIDEO_TITLE,
  channel_select: FIELDS.CHANNEL_SELECT,
  country_select: FIELDS.COUNTRY_SELECT,
  description: FIELDS.DESCRIPTION,
  keywords: FIELDS.KEYWORDS,
  language_select: FIELDS.LANGUAGE_SELECT,
  text_box: FIELDS.TEXT_BOX,
};

/**
 * @param raw
 * @returns {customFormFieldModel.type}
 */
export const customFormFieldModel = (raw) => ({
  type: TYPE_NAME_MAP[raw.type],
  config: raw.config || {},
});

/**
 * @typedef {{
 *   type: string,
 *   config: *
 * }}
 */
customFormFieldModel.type = null;
